import { controls,grouped } from "../controls";
const gls = {
label: "Gls",
pageLabel: "Gls",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
bulk:{columns:["gl_code","gl_display","long_descn","is_ho_gl"] },
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Gl Parameter",uid: "gl_parameter"},
{label: "Tags",uid: "gl_tags"},
{label:"Bulk",uid:"bulk"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "gl_code",maxlength:10}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Description",description:'Full partial search. e.g. You can search for Sugar Cane by typing gar or can.'}),
...controls.text({ tab: "filter",  placeHolder: "", name: "%gl_display%",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "filter", label: "Long Descn"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "long_descn",width:"col-sm-4",maxlength:100}),
...controls.checkBox({ tab: "filter",default:false, label: "Is Ho Gl", name: "is_ho_gl" }),
...controls.checkBox({ tab: "filter",default:true, label: "Active", name: "gl_active" }),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "gl_code",isRequired:true,maxlength:10 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Description",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "gl_display",isRequired:true,width:"col-sm-4",maxlength:100 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "Long Descn",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "long_descn",isRequired:true,width:"col-sm-4",maxlength:100}),
...controls.checkBox({ tab: "general", label: "Is Ho Gl",default:false, name: "is_ho_gl" }),
...controls.displayText({ tab: "gl_parameter", label: "Ledger Category",star:false}),
...controls.numberOnly({ tab: "gl_parameter",  placeHolder: "", name: "gl_parameter.ledger_category",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "gl_parameter", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "gl_parameter", label: "Report Type Id",default:false, name: "gl_parameter.report_type_id" }),
...controls.checkBox({ tab: "gl_parameter", label: "Transaction Allowed",default:false, name: "gl_parameter.transaction_allowed" }),
...controls.checkBox({ tab: "gl_parameter", label: "Transaction Allowed Branch",default:false, name: "gl_parameter.transaction_allowed_branch" }),
...controls.displayText({ tab: "gl_parameter", label: "Service Group",star:false}),
...controls.oc({ tab: "gl_parameter", c: "ServiceGroup", placeHolder: "Service Group Code", name: "gl_parameter.service_group_code", isRequired:false,fastpath:"service_groups"}),
...controls.showData({ tab: "gl_parameter", displaytype: "capital", data: "gl_parameter.service_group_display"}),

...controls.displayText({ tab:"gl_tags" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"gl_tags" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"gl_tags",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "gl_tags",
  requiredField: []
}, width: "col-sm-2"
}),
...controls.button({
tab:"gl_tags",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "gl_tags",
  requiredField: []
}, width: "col-sm-2"
}),
{
  tab:"gl_tags",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "gl_tags"
},
]
,history:{
perPage: 10,
reportHeader: "Gls",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Gl Code",accessor: "gl_code",},
{Header: "Gl",accessor: "gl_display",},
{Header: "Long Descn",accessor: "long_descn",},
{Header: "Is Ho Gl",accessor: "is_ho_gl",type:'tick'},
{Header: "Gl Active",accessor: "gl_active",type:'tick'},
]}};
export default gls;